import {
  HANDIN_PROVIDER,
  LTI1P3_PROVIDER,
  QUIZZES_PROVIDER,
  TURNITIN_PROVIDER,
} from '@core/assignments/constants';

type Input = {
  accessingAsStaff: boolean;
  hasSubmission: boolean;
  isEducator: boolean;
  provider: string;
};

export const getSubmissionCapabilities = ({
  accessingAsStaff,
  hasSubmission,
  isEducator,
  provider,
}: Input) => {
  const canOpen =
    !accessingAsStaff &&
    [
      HANDIN_PROVIDER,
      TURNITIN_PROVIDER,
      LTI1P3_PROVIDER,
      QUIZZES_PROVIDER,
    ].includes(provider) &&
    hasSubmission;

  return {
    canDelete:
      isEducator &&
      !accessingAsStaff &&
      provider === HANDIN_PROVIDER &&
      hasSubmission,
    canOpen,
    // Handin opens from an explicit control so its row/card does not
    // misleadingly advertise whole-row navigation.
    canOpenRow: canOpen && provider !== HANDIN_PROVIDER,
  };
};
